import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, FormGroup, Label } from 'reactstrap';
import Swal from 'sweetalert2';

// Validation Schema for Password Reset
const passwordResetValidationSchema = Yup.object({
  newPassword: Yup.string()
    // .min(8, "Password must be at least 8 characters")
    .required("Please enter a new password"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword'), null], "Passwords must match")
    .required("Please confirm your password"),
});

const PasswordResetModal = ({ isOpen, toggle, userId,authDetails,dispatch,resetPasswordRequest }) => {
  const formik = useFormik({
    initialValues: {
      newPassword: '',
      confirmPassword: ''
    },
    validationSchema: passwordResetValidationSchema,
    onSubmit: async (values) => {
      const formData = new FormData();
      formData.append("emp_id", userId);
      formData.append("password", values.newPassword);
      formData.append("create_by", authDetails?.user_id);

      // Call the reset password API or dispatch action
      dispatch(resetPasswordRequest(formData));

    //   Swal.fire({
    //     icon: 'success',
    //     title: 'Password Reset',
    //     text: 'Your password has been reset successfully.',
    //     confirmButtonColor: '#3085d6',
    //   });

      // Close modal and reset form
      toggle();
      formik.resetForm();
    }
  });

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Reset Password</ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          <FormGroup>
            <Label for="newPassword">New Password</Label>
            <Input
              type="password"
              name="newPassword"
              id="newPassword"
              value={formik.values.newPassword}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.newPassword && Boolean(formik.errors.newPassword)}
            />
            {formik.touched.newPassword && formik.errors.newPassword ? (
              <div className="text-danger">{formik.errors.newPassword}</div>
            ) : null}
          </FormGroup>

          <FormGroup>
            <Label for="confirmPassword">Confirm Password</Label>
            <Input
              type="password"
              name="confirmPassword"
              id="confirmPassword"
              value={formik.values.confirmPassword}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
            />
            {formik.touched.confirmPassword && formik.errors.confirmPassword ? (
              <div className="text-danger">{formik.errors.confirmPassword}</div>
            ) : null}
          </FormGroup>
        </form>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" className='btn button-reset'  onClick={formik.handleSubmit}><i className="fas fa-undo me-1" /></Button>
        <Button color="secondary" className="btn button-cancel" onClick={toggle}><i className="fas fa-sync me-1" /> Cancel</Button>
      </ModalFooter>
    </Modal>
  );
};

export default PasswordResetModal;
